import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Card, EmptyState, Skeleton } from '@proerp/ui';

/**
 * Karte mit Titel + Liste kurzer, klickbarer Zeilen (offene Aufgaben/Belege).
 * Handhabt Lade- und Leerzustand explizit (CLAUDE.md §9). Gemeinsame Basis der
 * Listen-Widgets im Dashboard.
 */
export function TaskCard({
  title,
  icon: Icon,
  isLoading,
  isEmpty,
  emptyText,
  header,
  children,
}: {
  title: string;
  icon: LucideIcon;
  isLoading: boolean;
  isEmpty: boolean;
  emptyText: string;
  /** Optionaler Inhalt rechts im Kopf (z. B. Ampel-Zusammenfassung). */
  header?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card className="overflow-hidden">
      <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-3">
        <span className="text-md text-foreground">{title}</span>
        {header}
      </div>
      {isLoading ? (
        <div className="flex flex-col gap-2 p-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} className="h-7 w-full" />
          ))}
        </div>
      ) : isEmpty ? (
        <EmptyState icon={Icon} title={emptyText} />
      ) : (
        <ul className="divide-y divide-border">{children}</ul>
      )}
    </Card>
  );
}

export function TaskRow({
  left,
  right,
  onClick,
}: {
  left: ReactNode;
  right: ReactNode;
  onClick: () => void;
}) {
  return (
    <li>
      <button
        type="button"
        onClick={onClick}
        className="flex w-full items-center justify-between gap-3 px-4 py-2.5 text-left text-sm hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <span className="min-w-0 truncate">{left}</span>
        <span className="shrink-0">{right}</span>
      </button>
    </li>
  );
}
